"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListHeader = void 0;
var classNames = require("classnames");
var React = require("react");
var SokReducerTypes = require("@caddigital/sok-reducers/lib/types");
var Table_1 = require("@caddigital/sok-ui/lib/components/Table");
var ColumnFilter_1 = require("components/ColumnFilter");
var components_1 = require("components");
var Utils = require("../../utils");
var createHeaderCell = function (_a) {
    var _b, _c, _d, _e;
    var column = _a.column, filteringOptions = _a.filteringOptions, filterBy = _a.filterBy, sortBy = _a.sortBy;
    var key = column.prop.toLowerCase();
    var caption = (_b = column.caption) !== null && _b !== void 0 ? _b : column.prop;
    var width = (_c = column.pixelWidth) !== null && _c !== void 0 ? _c : 0;
    var isFilterActive = filteringOptions.filters.some(function (filter) { return filter.prop === column.prop; });
    var filterInputValue = (_d = filteringOptions.filters.find(function (filter) { return filter.prop === column.prop; })) === null || _d === void 0 ? void 0 : _d.value;
    var sortOrder = ((_e = filteringOptions === null || filteringOptions === void 0 ? void 0 : filteringOptions.sort) === null || _e === void 0 ? void 0 : _e.prop) === column.prop
        ? filteringOptions.sort.order
        : undefined;
    var nextSortOrder = sortOrder === 'asc' ? 'desc' : 'asc';
    return (React.createElement("div", { key: key, "data-key": "__".concat(key), "data-length": caption.length, className: classNames('row__column', key), style: Utils.createCellStyle(width) },
        React.createElement("div", { onClick: function () { return sortBy(column.prop, nextSortOrder); } }, caption),
        React.createElement(Table_1.SortButton, { className: classNames('sort', 'd-none', 'd-desktop-table-cell'), order: sortOrder, onChange: function () { return sortBy(column.prop, nextSortOrder); } }),
        React.createElement(ColumnFilter_1.ColumnFilter, { className: classNames('filter', isFilterActive && 'active'), columnIdentifier: column.prop, inputType: 'text', textInputValue: filterInputValue !== null && filterInputValue !== void 0 ? filterInputValue : '', setColumnFilterString: function (_, value) { return filterBy(column.prop, value); }, clearColumnFilter: function () { return filterBy(column.prop, undefined); } })));
};
var createRowIcons = function (_a) {
    var listEntryType = _a.listEntryType, isSelectedAll = _a.isSelectedAll, onToggleSelectAll = _a.onToggleSelectAll;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'row__column narrow' },
            React.createElement(components_1.TableRowIcon, { className: isSelectedAll ? 'selected' : null, circle: true, icon: 'fa-check', onClick: onToggleSelectAll })),
        React.createElement("div", { className: 'row__column narrow' }),
        listEntryType === SokReducerTypes.REPORT && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: 'row__column narrow' }),
            React.createElement("div", { className: 'row__column narrow' })))));
};
var component = function (_a) {
    var data = _a.data, style = _a.style;
    var columns = data.columns, items = data.items, selectedUuids = data.selectedUuids, filteringOptions = data.filteringOptions, listEntryType = data.listEntryType, filterBy = data.filterBy, sortBy = data.sortBy, onSelectionChange = data.onSelectionChange;
    var isSelectedAll = selectedUuids.length === items.length && items.length > 0;
    var icons = createRowIcons({
        listEntryType: listEntryType,
        isSelectedAll: isSelectedAll,
        onToggleSelectAll: function () {
            return onSelectionChange(isSelectedAll ? [] : items.map(function (item) { return item.uuid; }));
        }
    });
    return (React.createElement("div", { className: 'header row', style: style },
        icons,
        columns.map(function (column) {
            return createHeaderCell({ column: column, filteringOptions: filteringOptions, filterBy: filterBy, sortBy: sortBy });
        })));
};
exports.ListHeader = component;
